import { uniqueDirectoryRecords } from './directoryOptions.js';

export function importedDirectoryLocations(records = [], resolution = {}) {
  const selected = [resolution.pickup?.selected, resolution.dropoff?.selected,
    ...(resolution.checkpoints || []).map(point => point.selected)].filter(record => record?.id);
  return uniqueDirectoryRecords([...selected, ...records]);
}

// A selection response changes one stop. Do not replay stale route/type data
// over other resolved stops or the type selected in the current form.
export function applyImportedCheckpointResult(current, record, index) {
  const changed = record?.draft?.checkPoints?.[index];
  if (!changed) return current;
  const checkPoints = [...(current.checkPoints || [])];
  checkPoints[index] = changed;
  const last = Math.max(0, checkPoints.length - 1);
  const indexes = current.type === 'CONTAINER_OUTBOUND' ? { pickup: Math.min(1, last), dropoff: last }
    : current.type === 'CONTAINER_INBOUND' ? { pickup: 0, dropoff: Math.min(1, last) } : { pickup: 0, dropoff: last };
  const patch = {};
  for (const [field, position] of Object.entries(indexes)) {
    const point = checkPoints[position];
    const selected = record.directoryResolution?.checkpoints?.find(item => Number(item.index) === position)?.selected;
    patch[`${field}LocationId`] = point?.placeId || '';
    patch[`${field}Location`] = selected?.id === point?.placeId ? selected
      : current[`${field}Location`]?.id === point?.placeId ? current[`${field}Location`] : null;
  }
  return { ...current, ...patch, checkPoints };
}
